var _path;

const _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgUsersFilled(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.40884 3.80952C9.40884 5.91347 7.72386 7.61905 5.64534 7.61905C3.56681 7.61905 1.88184 5.91347 1.88184 3.80952C1.88184 1.70558 3.56681 0 5.64534 0C7.72386 0 9.40884 1.70558 9.40884 3.80952ZM0 20.0001V14.2858C0 11.1299 2.52747 8.57153 5.64525 8.57153C8.76304 8.57153 11.2905 11.1299 11.2905 14.2858V20.0001H0ZM10.4635 2.04334C10.7103 2.57127 10.85 3.17212 10.85 3.80953C10.85 5.2884 10.0983 6.57046 9 7.20171C9.49198 7.75374 10.1719 8.09522 10.9229 8.09522C12.4242 8.09522 13.6412 6.73075 13.6412 5.04761C13.6412 3.36446 12.4242 2 10.9229 2C10.7663 2 10.6128 2.01484 10.4635 2.04334ZM15 18H12.2332V14C12.2332 11.9244 11.2867 10.0949 9.84812 9.01756C10.1904 8.91299 10.5507 8.85718 10.9226 8.85718C13.1745 8.85718 15 10.9039 15 13.4286V18Z",
    fill: "var(--primary-6)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersFilled);
export default __webpack_public_path__ + "static/media/usersFilled.0b5a762ac28dadda5859339c43afe636.svg";
export { ForwardRef as ReactComponent };